/**
 * Should render a input field with type-ahead suggestions to search for string values
 * NOT IMPLEMETED, see lit component mesh-query
 * @param _props
 */
export const MmgQueryCriteriaStringInput = () => {
  console.warn('String queries are not implemented in React yet!');
  return <></>;
};
